import { render, staticRenderFns } from "./DigitalPurchasesDetail.vue?vue&type=template&id=46ff9d72&scoped=true"
import script from "./DigitalPurchasesDetail.vue?vue&type=script&lang=js"
export * from "./DigitalPurchasesDetail.vue?vue&type=script&lang=js"
import style0 from "./DigitalPurchasesDetail.vue?vue&type=style&index=0&id=46ff9d72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ff9d72",
  null
  
)

export default component.exports